<template>
<div>
  <div class="home" v-if="pcShow">
    <headerTitle indexInit="6"/>
    <carouselPics :pics="pics" carouselIndex="1"/>
    <div class="block_div"></div>
    <titleBlock textChinese="商业视频案例" textEnglish="ENTERPRISE  SERVICE" />
    <div class="block_div"></div>
    <swiperCard @selectPics="selectPics"/>
    <div class="block_div"></div>
    <titleBlock textChinese="短视频案例" textEnglish="ENTERPRISE  SERVICE" />
    <div class="block_div"></div>
    <swiperCard4 @selectPics="selectPics"/>
    <div class="block_div"></div>
    <titleBlock textChinese="视频课程案例" textEnglish="ENTERPRISE  SERVICE" />
    <div class="block_div"></div>
    <swiperCard2 @selectPics="selectPics"/>
    <div class="block_div"></div>
    <titleBlock textChinese="多媒体展示案例" textEnglish="ENTERPRISE  SERVICE" />
    <div class="block_div"></div> 
    <!-- <swiperCard3 @selectPics="selectPics"/> -->
    <videoBlockSelectOdd  flagMash="1" :videoArray="videoArraySelect" @selectPics="selectPics" :flagIndex="1"/>
    <div class="block_div"></div>
    <titleBlock textChinese="剧情" textEnglish="ENTERPRISE  SERVICE" />
    <div class="block_div"></div>
    <swiperCard5 @selectPics="selectPics"/>
    <div class="block_div"></div>
    <footerBlock />
    <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>
  </div>

    <div v-if="!pcShow" class="mobile_casepage">
        <mobileHeader indexInit="6"/>
        <mobileCarousel :pics="images" carouselIndex="1"/>
        <mobileDivBlock />
        



         <mobileTitleBlock textChinese="商业视频案例" textEnglish="ENTERPRISE  SERVICE" />
    <mobileDivBlock />
    <!-- 1 -->
    <mobileswiperCard @selectPics="selectPics"/>
    <mobileDivBlock />
    <mobileTitleBlock textChinese="短视频案例" textEnglish="ENTERPRISE  SERVICE" />
    <mobileDivBlock />
    <!-- 2 -->
    <mobileswiperCard4 @selectPics="selectPics"/>
    <mobileDivBlock />
    <mobileTitleBlock textChinese="视频课程案例" textEnglish="ENTERPRISE  SERVICE" />
    <mobileDivBlock />
    <!-- 3 -->
    <mobileswiperCard2 @selectPics="selectPics"/>
    <mobileDivBlock />
    <mobileTitleBlock textChinese="多媒体展示案例" textEnglish="ENTERPRISE  SERVICE" />
    <mobileDivBlock />
    <!-- 4 -->
    <mobilevideoBlockSelectOdd  flagMash="1" :videoArray="videoArraySelect" @selectPics="selectPics" :flagIndex="1"/>
    <mobileDivBlock />
    <mobileTitleBlock textChinese="剧情" textEnglish="ENTERPRISE  SERVICE" />
    <mobileDivBlock />
    <!-- 5 -->
    <mobileswiperCard5 @selectPics="selectPics"/>
    <mobileDivBlock />
    <mobilefooterBlock />
    <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from '@/components/carouselPics.vue'
import headerTitle from '@/components/headerTitle.vue'
import titleBlock from '@/components/titleBlock.vue'
import serviceBlock from '@/components/serviceBlock.vue'
import videoBlock from '@/components/videoBlock.vue'
import serviceProgress from '@/components/serviceProgress.vue'
import serviceClient from '@/components/serviceClient.vue'
import footerBlock from '@/components/footerBlock.vue'
import serviceAdvanced from '@/components/serviceAdvanced.vue'
import swiperCard from '@/components/swiperCard.vue'
import swiperCard2 from '@/components/swiperCard2.vue'
import swiperCard3 from '@/components/swiperCard3.vue'
import swiperCard4 from '@/components/swiperCard4.vue'
import swiperCard5 from '@/components/swiperCard5.vue'
import videoEachBlock from '@/components/videoEachBlock.vue'
import videoBlockSelectOdd from '@/components/videoBlockSelectOdd.vue'
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobileTitleBlock from "@/components/mobileTitleBlock.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";
import mobileswiperCard from "@/components/mobileswiperCard.vue";
import mobileswiperCard4 from "@/components/mobileswiperCard4.vue";
import mobileswiperCard2 from "@/components/mobileswiperCard2.vue";
import mobilevideoBlockSelectOdd from "@/components/mobilevideoBlockSelectOdd.vue";
import mobileswiperCard5 from "@/components/mobileswiperCard5.vue";

export default {
  name: 'casepage',
  data() {
    return {
      videoUrl:{},
      videoFlag:false,
      pics:[
        {url:require('@/assets/imgs/banner701.jpeg'),linerow:1,text:'<span style="font-size:62px;color:#e91d62">客户满意</span><span style="font-size:54px;color:#fff">是星沐互娱最好的作品</span>'},
        // {url:require('@/assets/imgs/banner02.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner03.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner04.jpeg'),text:'你好'}
      ],
      videoArray:[
        [{url:require('@/assets/imgs/video01.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
        {url:require('@/assets/imgs/video02.jpeg'),text:'郎佳子彧的手工课'}],
        [{url:require('@/assets/imgs/video03.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
        {url:require('@/assets/imgs/video04.jpeg'),text:'郎佳子彧的手工课'}],
        [{url:require('@/assets/imgs/video05.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
        {url:require('@/assets/imgs/video06.jpeg'),text:'郎佳子彧的手工课'}],
        [{url:require('@/assets/imgs/video07.jpeg'),text:'2020体彩竞猜广告-去赛场篇'},
        {url:require('@/assets/imgs/video08.jpeg'),text:'郎佳子彧的手工课'}],
        
      ],
      videoArraySelect:[ 
        {url:require('@/assets/video/video601.jpg'),text:'箭牌Arrow发布会',videoUrl:require('@/assets/video/video601.mp4')},
        {url:require('@/assets/video/video602.jpg'),text:'产城之梦四折幕三维',videoUrl:require('@/assets/video/video602.mp4')},
        {url:require('@/assets/video/video603.jpg'),text:'中国电信裸眼3D',videoUrl:require('@/assets/video/video603.mp4')},
        {url:require('@/assets/video/video604.jpg'),text:'国家地震局球幕专题片',videoUrl:require('@/assets/video/video604.mp4')},
        {url:require('@/assets/video/video605.jpg'),text:'惠普暗影精灵笔记本发布会异形屏',videoUrl:require('@/assets/video/video605.mp4')},
        {url:require('@/assets/video/video606.jpg'),text:'北京世界公园大战外星人夜游投影',videoUrl:require('@/assets/video/video606.mp4')},
        {url:require('@/assets/video/video607.jpg'),text:'浙江密赛山崖激光秀',videoUrl:require('@/assets/video/video607.mp4')},
        {url:require('@/assets/video/video608.jpg'),text:'徐州未来智慧城市网络沙盘',videoUrl:require('@/assets/video/video608.mp4')},
        
      ],
      pcShow: true,
      images: [
        {url:require('@/assets/imgs/banner701.jpeg'),linerow:1,text:'<span style="font-size:16px;color:#e91d62">客户满意</span><span style="font-size:16px;color:#fff">是星沐互娱最好的作品</span>'},
        ]
    }
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlock,
    videoBlock,
    serviceProgress,
    serviceClient,
    footerBlock,
    serviceAdvanced,
    swiperCard,
    swiperCard2,
    swiperCard3,
    swiperCard4,
    swiperCard5,
    videoEachBlock,
    videoBlockSelectOdd,
    mobileHeader,
    mobileCarousel,
    mobileDivBlock,
    mobileTitleBlock,
    mobilefooterBlock,
    mobileswiperCard,
    mobileswiperCard4,
    mobileswiperCard2,
    mobilevideoBlockSelectOdd,
    mobileswiperCard5
  },
  methods:{
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW < 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    },
    closeVideoFn(){
      this.videoFlag = false
    },
    selectPics(item){
      this.videoFlag = true
      this.videoUrl.videoUrl = item.videoUrl
      console.log(this.videoUrl,'this.videoUrl')
    },
  },
  mounted() {
    this.widthChange();
    window.addEventListener("resize", this.widthChange);
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
}
</script>
<style lang="less">

</style>
